import moment from "moment";
import { useCallback } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { LUEvent, useEventsSearch } from "../../../data/events.api";
import { SearchSource } from "../MapSearch";

export const useEventsSource = (query: string): SearchSource<LUEvent> => ({
  title: "Events",
  source: useEventsSearch(query),
  transformer: useCallback((e) => {
    return {
      icon: FaCalendarAlt,
      iconColour: "lancsBlue.500",
      title: e?.title,
      subtitle: e?.location?.locationName,
      tag: moment(e?.startDate)?.fromNow(),
      to: `/events/${e?.eventId}`,
    };
  }, []),
  priority: 0,
});
